import type { IntlShape } from 'react-intl';

import { templateBuilderMessages } from '../templateBuilder.messages';

// Copies saved before the label was localized carry the English suffix in every locale
const LEGACY_COPY_SUFFIX = '(custom)';
// Stands in for the name so the localized label splits into what goes before and after it
const NAME_MARKER = '\u0000';

const hasLocalizedCopyLabel = (intl: IntlShape, name: string) => {
  const [prefix = '', suffix = ''] = intl
    .formatMessage(templateBuilderMessages.customTemplateCopyName, {
      templateName: NAME_MARKER,
    })
    .split(NAME_MARKER)
    .map((part) => part.trim());
  return (
    Boolean(prefix || suffix) &&
    name.length > prefix.length + suffix.length &&
    name.startsWith(prefix) &&
    name.endsWith(suffix)
  );
};

/**
 * Names the personal copy made when a user edits a template they cannot change.
 * A source already carrying the legacy or the user's localized label keeps its name.
 */
export const formatCustomTemplateCopyName = (intl: IntlShape, name = ''): string => {
  const trimmedName = name.trim();
  const isAlreadyCopy =
    trimmedName.endsWith(LEGACY_COPY_SUFFIX) || hasLocalizedCopyLabel(intl, trimmedName);
  return isAlreadyCopy
    ? name
    : intl.formatMessage(templateBuilderMessages.customTemplateCopyName, {
        templateName: name,
      });
};
